import { Button, CircularProgress } from "@mui/material";
import type { ReactNode } from "react";

// Lines the button up with the box of the TextInput next to it: the input's label sits above the
// box, and the box is 44 px high.
const TEXT_INPUT_LABEL_OFFSET = 1.5;
const TEXT_INPUT_BOX_HEIGHT = 44;
const MIN_WIDTH = 100;

type Props = {
  onClick: () => void;
  isDisabled: boolean;
  isPending: boolean;
  children: ReactNode;
};

/** The action next to a TextInput, e.g. "Ověřit" of the coupon or the affiliate code. */
export const InputActionButton = ({
  onClick,
  isDisabled,
  isPending,
  children,
}: Props) => (
  <Button
    variant="outlined"
    onClick={onClick}
    disabled={isDisabled}
    sx={{
      minWidth: MIN_WIDTH,
      height: TEXT_INPUT_BOX_HEIGHT,
      mt: TEXT_INPUT_LABEL_OFFSET,
    }}
    startIcon={isPending ? <CircularProgress size={20} /> : undefined}
  >
    {children}
  </Button>
);
